<script>
import XmlChannelStatusCardHeader from './XmlChannelStatusCardHeader';

export default {
  name: 'XmlChannelStatusNyiCard',
  components: {
    XmlChannelStatusCardHeader,
  },
  props: {
    xmlChannel: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <v-flex>
    <xml-channel-status-card-header :xml-channel="xmlChannel"/>
    <v-divider class="mx-2"/>
    <v-card-text class="status-card-nyi__box">
      <span class="status-card-nyi__text title">
        {{ $t('xmlChannelStatus.xmlChannelStatusCard.notImplementedYet') }}
      </span>
    </v-card-text>
    <v-divider class="mx-2 pt-1"></v-divider>
    <v-btn color="primary" disabled outline>
      {{ $t('xmlChannelStatus.xmlChannelStatusCard.jobList') }}
    </v-btn>
  </v-flex>
</template>

<style lang="scss">
  .status-card-nyi {
    &__box {
      text-align: center;
      min-height: 127px;
      padding-top: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/xmlChannelStatus/XmlChannelStatusNyiCard.vue